var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "layout" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: { id: "tpi_edi", placeholder: "Escriba..." },
                model: {
                  value: _vm.modelValue.tpi_edi,
                  callback: function($$v) {
                    _vm.$set(_vm.modelValue, "tpi_edi", $$v)
                  },
                  expression: "modelValue.tpi_edi"
                }
              },
              [_vm._v("\n                    TPI\n                ")]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  vMoney: "",
                  format: _vm.decimal,
                  id: "dimension_edi",
                  placeholder: "Escriba..."
                },
                model: {
                  value: _vm.modelValue.dimension_edi,
                  callback: function($$v) {
                    _vm.$set(_vm.modelValue, "dimension_edi", $$v)
                  },
                  expression: "modelValue.dimension_edi"
                }
              },
              [_vm._v("\n                    Alto\n                ")]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  vMoney: "",
                  format: _vm.decimal,
                  id: "dimension2_edi",
                  placeholder: "Escriba..."
                },
                model: {
                  value: _vm.modelValue.dimension2_edi,
                  callback: function($$v) {
                    _vm.$set(_vm.modelValue, "dimension2_edi", $$v)
                  },
                  expression: "modelValue.dimension2_edi"
                }
              },
              [_vm._v("\n                    Ancho\n                ")]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  vMoney: "",
                  format: _vm.int,
                  id: "pieza_edi",
                  placeholder: "Escriba..."
                },
                model: {
                  value: _vm.modelValue.pieza_edi,
                  callback: function($$v) {
                    _vm.$set(_vm.modelValue, "pieza_edi", $$v)
                  },
                  expression: "modelValue.pieza_edi"
                }
              },
              [_vm._v("\n                    Cantidad\n                ")]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: { id: "codigo_rep_edi", placeholder: "Escriba..." },
                model: {
                  value: _vm.modelValue.codigo_rep_edi,
                  callback: function($$v) {
                    _vm.$set(_vm.modelValue, "codigo_rep_edi", $$v)
                  },
                  expression: "modelValue.codigo_rep_edi"
                }
              },
              [_vm._v("\n                    Componente\n                ")]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: { id: "repair_method_edi", placeholder: "Escriba..." },
                model: {
                  value: _vm.modelValue.repair_method_edi,
                  callback: function($$v) {
                    _vm.$set(_vm.modelValue, "repair_method_edi", $$v)
                  },
                  expression: "modelValue.repair_method_edi"
                }
              },
              [
                _vm._v(
                  "\n                    Método de Reparación\n                "
                )
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: { id: "descripcion_edi", placeholder: "Escriba..." },
                model: {
                  value: _vm.modelValue.descripcion_edi,
                  callback: function($$v) {
                    _vm.$set(_vm.modelValue, "descripcion_edi", $$v)
                  },
                  expression: "modelValue.descripcion_edi"
                }
              },
              [_vm._v("\n                    Descripción\n                ")]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: { id: "tipo_material_edi", placeholder: "Escriba..." },
                model: {
                  value: _vm.modelValue.tipo_material_edi,
                  callback: function($$v) {
                    _vm.$set(_vm.modelValue, "tipo_material_edi", $$v)
                  },
                  expression: "modelValue.tipo_material_edi"
                }
              },
              [
                _vm._v(
                  "\n                    Tipo de material\n                "
                )
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  vMoney: "",
                  format: _vm.decimal,
                  id: "labour_rate_edi",
                  placeholder: "Escriba..."
                },
                model: {
                  value: _vm.modelValue.labour_rate_edi,
                  callback: function($$v) {
                    _vm.$set(_vm.modelValue, "labour_rate_edi", $$v)
                  },
                  expression: "modelValue.labour_rate_edi"
                }
              },
              [_vm._v("\n                    Lb. Rate\n                ")]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  vMoney: "",
                  format: _vm.decimal,
                  id: "handling_total_edi",
                  placeholder: "Escriba..."
                },
                model: {
                  value: _vm.modelValue.handling_total_edi,
                  callback: function($$v) {
                    _vm.$set(_vm.modelValue, "handling_total_edi", $$v)
                  },
                  expression: "modelValue.handling_total_edi"
                }
              },
              [_vm._v("\n                    Handling total\n                ")]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  vMoney: "",
                  format: _vm.decimal,
                  id: "tax_total_edi",
                  placeholder: "Escriba..."
                },
                model: {
                  value: _vm.modelValue.tax_total_edi,
                  callback: function($$v) {
                    _vm.$set(_vm.modelValue, "tax_total_edi", $$v)
                  },
                  expression: "modelValue.tax_total_edi"
                }
              },
              [_vm._v("\n                    Total Tax\t\n                ")]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  vMoney: "",
                  format: _vm.decimal,
                  id: "horas_hombre_edi",
                  placeholder: "Escriba..."
                },
                model: {
                  value: _vm.modelValue.horas_hombre_edi,
                  callback: function($$v) {
                    _vm.$set(_vm.modelValue, "horas_hombre_edi", $$v)
                  },
                  expression: "modelValue.horas_hombre_edi"
                }
              },
              [
                _vm._v(
                  "\n                    Horas hombres\t\n                "
                )
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  vMoney: "",
                  format: _vm.decimal,
                  id: "precio_edi",
                  placeholder: "Escriba..."
                },
                model: {
                  value: _vm.modelValue.precio_edi,
                  callback: function($$v) {
                    _vm.$set(_vm.modelValue, "precio_edi", $$v)
                  },
                  expression: "modelValue.precio_edi"
                }
              },
              [_vm._v("\n                    Precio\t\n                ")]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: { id: "damage_code", placeholder: "Escriba..." },
                model: {
                  value: _vm.modelValue.damage_code,
                  callback: function($$v) {
                    _vm.$set(_vm.modelValue, "damage_code", $$v)
                  },
                  expression: "modelValue.damage_code"
                }
              },
              [_vm._v("\n                    Damage\n                ")]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: { id: "localizacion_id_edi", placeholder: "Escriba..." },
                model: {
                  value: _vm.modelValue.localizacion_id_edi,
                  callback: function($$v) {
                    _vm.$set(_vm.modelValue, "localizacion_id_edi", $$v)
                  },
                  expression: "modelValue.localizacion_id_edi"
                }
              },
              [_vm._v("\n                    Localización\n                ")]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: { id: "tipo_unidad", placeholder: "Escriba..." },
                model: {
                  value: _vm.modelValue.tipo_unidad,
                  callback: function($$v) {
                    _vm.$set(_vm.modelValue, "tipo_unidad", $$v)
                  },
                  expression: "modelValue.tipo_unidad"
                }
              },
              [_vm._v("\n                    Tipo unidad\n                ")]
            )
          ],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "modal-buttons" }, [
      _c(
        "button",
        {
          staticClass: "btn-success",
          attrs: { type: "button" },
          on: { click: _vm.aceptar }
        },
        [
          _c("i", { staticClass: "fa fa-check" }),
          _c("span", [_vm._v("Aceptar")])
        ]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn-danger btn--text",
          attrs: { type: "button" },
          on: {
            click: function($event) {
              return _vm.$emit("cerrar")
            }
          }
        },
        [
          _c("i", { staticClass: "fa fa-times" }),
          _c("span", [_vm._v("Cerrar")])
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__header" }, [
      _c("div", { staticClass: "layout__title" }, [
        _c("h3", [_vm._v("Detalle")])
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3fce1603", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3fce1603","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/sistema/Detalle.vue
// module id = 342
// module chunks = 0